// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__uxZ1R","title":"ClientInsurance_title__wXp-m","itemText":"ClientInsurance_itemText__2KYrs"};